import React, { useState } from "react";
// models
import {
  SubparticipanteModel,
  initialValuesSubparticipanteModel,
} from "../models/AgregarParticipanteModel/agregarparticipante.model";
// redux
import { useNavigate } from "react-router";
import { useEncrypt } from "./useEncrypt";

export const useAgregarParticipante = () => {
  // route
  const navigate = useNavigate();
  const { decrypt } = useEncrypt();
  // state
  const [subparticipantes, setSubparticipantes] = useState<Array<SubparticipanteModel>>([]);
  const [subParticipante, setSubParticipante] = useState<SubparticipanteModel>(initialValuesSubparticipanteModel);
  const [añadirparticipante, setAñadirparticipante] = useState<boolean>(false);
  // functions
  const cambiarestadoAñadirparticipante = (e: any) => {
    return setAñadirparticipante(e.target.value);
  };
  const agregarFila = async () => {
    try {
      subParticipante.postulacion_id = decrypt(localStorage.getItem('id_postulacion'));
      setSubparticipantes([...subparticipantes, subParticipante]);
      return setSubParticipante(initialValuesSubparticipanteModel);
    } catch (error) {
      return console.error(error);
    }
  };
  const eliminarFila = async (index: number, numero_documento: any) => {
    let infoupdate = subparticipantes.filter((data: any, i: number) => i !== index);
    setSubparticipantes(infoupdate);
  };
  const continuar = () => {
    navigate("/usuario/seleccionarCategoria");
  };
  return {
    subparticipante: subParticipante,
    setSubParticipante,
    subparticipantes,
    añadirparticipante,
    cambiarestadoAñadirparticipante,
    agregarFila,
    eliminarFila,
    continuar,
  };
};
